import date from '@/tools/date'

export default ({ store }, inject) => {
  if (process.browser) {
    return inject('date', date)
  }
}
